import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionService } from 'src/app/store/session/session.service';
import { SessionQuery } from 'src/app/store/session/session.query';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import { getPasswordRules } from 'src/app/shared/password-rules';
import { PasswordValidators } from 'ngx-validators';
import { ToastrService } from 'ngx-toastr';
import { StatusRegisterResponse } from 'src/app/shared/model/login';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  animations: [SharedAnimations]
})
export class ResetPasswordComponent implements OnInit {

  statusUser: string = null;
  showError = false;
  showSuccess = false;
  messageError = '';
  loading$: Observable<boolean>;
  loadingText: string;
  form: FormGroup;
  textError = '';

  showPassword = false;
  showConfirmPassword = false;
  passwordValidators = [];

  email: string;
  userId: string;
  verifCode: string;
  isVerify = false;
  verifySuccess = false;
  tokenInvalid = false;

  constructor(
    private fb: FormBuilder,
    private sessionService: SessionService,
    private sessionQuery: SessionQuery,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.passwordValidators = getPasswordRules();
    const validatorsPassword = this.passwordValidators.map(v => v.validator);
    validatorsPassword.push(Validators.required);

    this.loading$ = this.sessionQuery.selectLoading();
    this.form = this.fb.group({
      password: ['', validatorsPassword],
      passwordConfirm: ['', [Validators.required]],
    }, {
      validators: [PasswordValidators.mismatchedPasswords('password', 'passwordConfirm')]
    });

    this.isVerify = true;

    const { user, code } = this.route.snapshot.queryParams;
    this.userId = user;
    this.verifCode = code;
    this.sessionService.verifyUser(this.userId, this.verifCode).subscribe(response => {
      this.isVerify = false;
      if (response.success) {
        this.verifySuccess = true;
        this.email = response.email;
      } else if (response.email) {
        this.tokenInvalid = true;
      }
    }, error => {
      this.isVerify = false;
    });

  }

  resetPassword(values) {
    this.showError = false;
    this.loadingText = 'Aguarde...';
    this.sessionService.resetPassword(this.userId, this.verifCode, values.password).subscribe((response: any) => {
      if (response.success) {
        this.toastr.success('', 'Nova senha registrada com sucesso. Aguarde enquanto você é redirecionado para a página inicial.', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true,
          positionClass: 'toast-bottom-center'
        });
        setTimeout(() => {
          this.sessionService.login(this.email, values.password);
        }, 3000);
      } else {
        this.toastr.error('', 'Não foi possível alterar a sua senha.');
        this.showError = true;
        this.messageError = StatusRegisterResponse[response.status];
        if (response.status === 'UNREGISTERED_USER') {
          this.messageError += ' Aguarde enquanto redirecionamos para o cadastramento de senha.';
          setTimeout(
            () => { this.router.navigate(['/login/verification'], { queryParams: { user: this.userId, code: this.verifCode } }) },
            3000);
        }
      }
    }, err => {

    });

  }

  closeAlert() {
    this.showError = false;
  }

  get password() {
    return this.form.get('password');
  }

}
